export const CHATBOT_API_VERSION = '/api/v1/';

const CHATBOT_APIS: { [key: string]: string } = {
  helpURL: ``,
  legalTermsURL: ``,
  privacyURL: `https://www.dupont.com/privacy.html`,
  contactUsURL: `https://www.dupont.com/personal-protection/protective-apparel-contact-us.html`,
  waterResourceURL: `https://www.dupont.com/resource-center.html?BU=ppe&tagId=DuPont:brands/tyvek_td`,
  promptsURL: `/chatbot/prompts`,
  chatsHistoryURL: `/chat-history`,
  queryURL: `/chatbot/query`,
  chatHistoryDetailURL: `/chat-history/{history_id}`,
  chatFeedbackURL: `/chats/{chat_id}/feedback`,
  chatReviewURL: `/chats/{chat_id}/review`,
  settingsURL: `/users/settings/{setting_id}`,
  reportLogin: `/users`,
  updateChatTitleURL: `/chat-history/{%id}/title`,
  pinChat: `/pin-chat-history`,
  chemicalList: '/chemical-list',
  industryList: '/industry-list',
  byIndustry: '/product-selection-industry',
  byHazard: '/product-selection-chemical',
  hazardPermeation: `/hazard/permeation-data`,
  chemicalClassPermeation: `/chemical-class/permeation-data`,
  adminChatsURLs: `/admin/chats`,
  fabricPermeation: `/fabrics/permeation-data`,
  chatTranslateURL: `/admin/chats/{chat_id}/translate`,
};
export default CHATBOT_APIS;

interface IRegionalURLs {
  contactUs: string;
  resourceCenter: string;
  privacyURL: string;
  helpURL: string;
  legalTermsURL: string;
  domain: string;
  contentUrl: string;
  region: string;
  tipsBestPracticesURL: string;
}
export const getRegionalURLS = (region: string): IRegionalURLs => {
  region = region.toLowerCase();
  const resources: { [key: string]: any } = {
    us: {
      domain: 'https://www.dupont.com',
      contactUs: 'https://www.dupont.com/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.com/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.com/privacy.html`,
      contentUrl: '/content/dupont/amer/us/en/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.com/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'us',
    },
    gb: {
      domain: 'https://www.safespec.dupont.co.uk',
      contactUs:
        'https://www.dupont.co.uk/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.co.uk/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.co.uk/privacy.html`,
      contentUrl: '/content/dupont/emea/gb/en/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.co.uk/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `http://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC-Assistant-UK-210325-r5.pdf`,
      region: 'eu',
    },
    de: {
      domain: 'https://www.safespec.dupont.de',
      contactUs: 'https://www.dupont.de/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.de/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.de/privacy.html`,
      contentUrl: '/content/dupont/emea/de/de/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: `https://www.dupont.de/legal-notices-and-terms-of-use.html`,
      legalTermsURL: `https://www.dupont.de/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.de/content/dam/dupont/amer/us/en/personal-protection/public/documents/de/DuPont_SafeSPEC_Assistant_brochure_EMEA_DE.pdf`,
      region: 'de',
    },
    es: {
      domain: 'https://www.safespec.dupont.es',
      contactUs: 'https://www.dupont.es/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.es/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.es/privacy.html`,
      contentUrl: '/content/dupont/latam/ar/es/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.es/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.es/content/dam/dupont/amer/us/en/personal-protection/public/documents/es/DuPont_SafeSPEC_Assistant_brochure_EMEA_ES.pdf`,
      region: 'es',
    },
    it: {
      domain: 'https://www.safespec.dupont.it',
      contactUs: 'https://www.dupont.it/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.it/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.it/privacy.html`,
      contentUrl: '/content/dupont/emea/it/it/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: ` https://www.dupont.it/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.it/content/dam/dupont/amer/us/en/personal-protection/public/documents/it/DuPont_SafeSPEC_Assistant_brochure_EMEA_IT.pdf`,
      region: 'it',
    },
    fr: {
      domain: 'https://www.safespec.fr',
      contactUs:
        'https://www.dupontdenemours.fr/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupontdenemours.fr/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupontdenemours.fr/privacy.html`,
      contentUrl: '/content/dupont/emea/fr/fr/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupontdenemours.fr/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `http://www.dupontdenemours.fr/content/dam/dupont/amer/us/en/personal-protection/public/documents/fr/DuPont_SafeSPEC_Assistant_brochure_EMEA_FR.pdf`,
      region: 'fr',
    },
    ap: {
      domain: 'https://www.safespec.dupont.asia',
      contactUs:
        'https://www.dupont.com.sg/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.com.sg/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.com.sg/privacy.html`,
      contentUrl: '/content/dupont/apac/ap/en/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.com/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'ap',
    },
    kr: {
      domain: 'https://www.safespec.dupont.co.kr',
      contactUs:
        'https://www.dupont.co.kr/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.co.kr/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.co.kr/privacy.html`,
      contentUrl: '/content/dupont/apac/kr/ko/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.co.kr/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'kr',
    },
    in: {
      domain: 'https://www.safespec.dupont.co.in',
      contactUs:
        'https://www.dupont.co.in/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.co.in/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.co.in/privacy.html`,
      contentUrl: '/content/dupont/apac/in/en/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.com/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'in',
    },
    jp: {
      domain: 'https://www.safespec.dupont.co.jp',
      contactUs:
        'https://www.dupont.co.jp/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.co.jp/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.co.jp/privacy.html`,
      contentUrl: '/content/dupont/apac/jp/ja/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.com/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'jp',
    },
    cn: {
      domain: 'https://www.safespec.dupont.cn',
      contactUs: 'https://www.dupont.cn/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.cn/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.cn/privacy.html`,
      contentUrl: '/content/dupont/apac/cn/zh/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.cn/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'cn',
    },
    br: {
      domain: 'https://www.safespec.dupont.com.br',
      contactUs:
        'https://www.dupont.com.br/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.com.br/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.com.br/privacy.html`,
      contentUrl: '/content/dupont/latam/br/pt/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.com.br/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'br',
    },
    mx: {
      domain: 'https://www.safespec.dupont.mx',
      contactUs: 'https://www.dupont.mx/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.mx/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.mx/privacy.html`,
      contentUrl: '/content/dupont/latam/mx/es/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.mx/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'mx',
    },
    ar: {
      domain: 'https://www.safespec.dupont.com.ar',
      contactUs: 'https://www.dupont.mx/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.mx/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.com.ar/privacy.html`,
      contentUrl: '/content/dupont/latam/ar/es/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.com.ar/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'ar',
    },
    cl: {
      domain: 'https://www.safespec.dupont.cl',
      contactUs: 'https://www.dupont.mx/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.mx/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.mx/privacy.html`,
      contentUrl: '/content/dupont/latam/cl/es/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.mx/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'cl',
    },
    ad: {
      domain: 'https://www.safespec.dupont.co',
      contactUs: 'https://www.dupont.mx/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.mx/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.mx/privacy.html`,
      contentUrl: '/content/dupont/latam/ad/es/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.mx/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'ad',
    },
    ca: {
      domain: 'https://www.safespec.dupont.ca/fr',
      contactUs:
        'https://www.dupont.ca/fr/personal-protection/protective-apparel-contact-us.html?src=SafeSPEC-Assistant',
      resourceCenter: 'https://www.dupont.ca/fr/resource-center.html?BU=ppe',
      privacyURL: `https://www.dupont.ca/fr/privacy.html`,
      contentUrl: '/content/dupont/latam/ca/fr/es/personal-protection/safespec/selector-tool/selectortool-chemical',
      helpURL: ``,
      legalTermsURL: `https://www.dupont.ca/fr/legal-notices-and-terms-of-use.html`,
      tipsBestPracticesURL: `https://www.dupont.com/content/dam/dupont/amer/us/en/personal-protection/public/documents/en/DUPO-25-34649-SafeSPEC_Assistant-NA-lm-210325-r1.pdf`,
      region: 'ca',
    },
  };
  return resources[region] ? resources[region] : resources['us'];
};
